/**
 * A charger Ã  partir d'un JSON
 */

export class RedirectURL {

 public static  authority =" https://localhost:8443/oidc" ;
  public static client_id= "chatbot777-7777-7777-7777-777777777777" ;
  public static scope= "openid" ;
  public static response_type= "id_token token" ;
  public static redirect_uri= "https://localhost:4200" ;
  public static uri = "classic part" ;


}
